import {
  ImageBackground,
  View,
  Text,
  StyleSheet,
  Platform,
} from "react-native";
import TimerBg from "../../../../assets/timer.png";
import { formatTimeParts } from "../../../../utils/helpers/date";
import { Timer } from "../../../../assets";

const TimerBox = ({ value, label }: { value: string; label?: string }) => {
  const isNative = Platform.OS !== "web";
  return (
    <View
      style={{
        width: 46,
        height: 42,
        borderRadius: 6,
        //   backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: "center",
        alignItems: "center",
        marginHorizontal: 0,
        flexDirection: "row",
        paddingBottom: isNative ? 0 : 4,
        paddingTop: isNative ? 4 : 0,
      }}
    >
      <Text
        style={{
          color: "#fff",
          fontWeight: "900",
          fontSize: 20,
          includeFontPadding: false,
        }}
      >
        {value}
      </Text>
      {label && (
        <Text
          style={{
            //   position: "absolute",
            //   bottom: 2,

            fontSize: 20,
            color: "#fff",
            fontWeight: "700",
            includeFontPadding: false,
          }}
        >
          {label}
        </Text>
      )}
    </View>
  );
};

export const TournamentTimer = ({ timeLeft }) => {
  const { d, h, m, s } = formatTimeParts(timeLeft);

  return (
    <ImageBackground
      source={Timer}
      resizeMode="stretch"
      style={{
        alignSelf: "center",
        gap: 6,
        paddingLeft: Number(d) > 0 ? 2 : 20,
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {Number(d) > 0 && <TimerBox value={d} label="d" />}
        <TimerBox value={h} />

        {/* <Text style={styles.dots}>:</Text> */}

        <TimerBox value={m} />

        {/* <Text style={styles.dots}>:</Text> */}

        <TimerBox value={s} />
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  dots: {
    color: "#fff",
    fontSize: 18,
    fontWeight: "900",
    marginHorizontal: 2,
  },
});
